import { Reducer } from 'redux';
import { ErrorResponse } from 'core/http/response';
import { ManifestActions, ManifestsActions } from './actionType';
import { Manifest } from './types';

export interface ManifestsState {
    isLoading: boolean;
    error?: ErrorResponse;
    manifest?: Manifest;
}

export const manifestsInitialState: Readonly<ManifestsState> = {
    isLoading: false,
    error: undefined,
    manifest: undefined,
};

const manifests: Reducer<ManifestsState, ManifestsActions> = (
    state = manifestsInitialState,
    action
): ManifestsState => {
    switch (action.type) {
        case ManifestActions.CREATE_MANIFEST_REQUEST: {
            return {
                ...state,
                error: undefined,
                isLoading: true,
            };
        }
        case ManifestActions.CREATE_MANIFEST_SUCCESS: {
            return {
                ...state,
                error: undefined,
                isLoading: false,
                manifest: action.payload,
            };
        }
        case ManifestActions.CREATE_MANIFEST_ERROR: {
            return {
                ...state,
                error: action.error,
                isLoading: false,
                manifest: state.manifest,
            };
        }

        case ManifestActions.GET_MANIFEST_BY_ID_REQUEST: {
            return { ...state, isLoading: true, error: undefined };
        }
        case ManifestActions.GET_MANIFEST_BY_ID_SUCCESS: {
            return { ...state, error: undefined, isLoading: false, manifest: action.payload };
        }
        case ManifestActions.GET_MANIFEST_BY_ID_ERROR: {
            return { ...state, error: action.error, isLoading: false };
        }

        case ManifestActions.UPDATE_MANIFEST_REQUEST: {
            return { ...state, isLoading: true, error: undefined };
        }
        case ManifestActions.UPDATE_MANIFEST_SUCCESS: {
            return { ...state, isLoading: false, error: undefined, manifest: action.payload };
        }
        case ManifestActions.UPDATE_MANIFEST_ERROR: {
            return { ...state, isLoading: false, error: action.error };
        }

        case ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_REQUEST: {
            return { ...state, isLoading: true, error: undefined };
        }
        case ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_SUCCESS: {
            return { ...state, isLoading: false, error: undefined, manifest: action.payload };
        }
        case ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_ERROR: {
            return { ...state, isLoading: false, error: action.error };
        }

        case ManifestActions.ARCHIVE_MANIFEST_REQUEST: {
            return { ...state, isLoading: true, error: undefined };
        }
        case ManifestActions.ARCHIVE_MANIFEST_SUCCESS: {
            return { ...state, isLoading: false, error: undefined, manifest: action.payload };
        }
        case ManifestActions.ARCHIVE_MANIFEST_ERROR: {
            return { ...state, isLoading: false, error: action.error };
        }

        case ManifestActions.UNARCHIVE_MANIFEST_REQUEST: {
            return { ...state, isLoading: true, error: undefined };
        }
        case ManifestActions.UNARCHIVE_MANIFEST_SUCCESS: {
            return { ...state, isLoading: false, error: undefined, manifest: action.payload };
        }
        case ManifestActions.UNARCHIVE_MANIFEST_ERROR: {
            return { ...state, isLoading: false, error: action.error };
        }

        case ManifestActions.ADD_JOB_TO_MANIFEST_REQUEST: {
            return { ...state, isLoading: true, error: undefined };
        }
        case ManifestActions.ADD_JOB_TO_MANIFEST_SUCCESS: {
            return { ...state, isLoading: false, error: undefined, manifest: action.payload };
        }
        case ManifestActions.ADD_JOB_TO_MANIFEST_ERROR: {
            return { ...state, isLoading: false, error: action.error };
        }

        default: {
            return state;
        }
    }
};

export default manifests;
